import * as React from "react"
import { Box, ChakraProvider, Flex, Image, Link, Text } from "@chakra-ui/react"
import theme from "./theme"
import styled from "@emotion/styled"
import { AIDemo } from "./components/AIDemo"
import {
  contactUsLink,
  contactUsMessage,
  copyRightMessage,
  dmazeLink,
} from "./constants/texts"

const FooterLink = styled(Link)`
  color: #05a69d;
  font-weight: 700;
  text-decoration: underline;
`
export const App = () => {
  return (
    <ChakraProvider theme={theme}>
      <Box marginBottom="70px" padding="32px">
        <Flex>
          <Link href={dmazeLink}>
            <Image src="./logo.png" alt="DMAZE" />
          </Link>
        </Flex>
        <Flex direction="column" align="center" justify="center">
          <AIDemo />
        </Flex>
      </Box>
      <Flex
        position="fixed"
        bottom="0"
        width="100%"
        height="70px"
        alignItems={"center"}
        justifyContent="space-between"
        role={"footer"}
        bgColor={"dmazegray.100"}
      >
        <Flex width="40%">
          <Box
            marginLeft="96px"
            marginRight="96px"
            _hover={{ textDecoration: "none" }}
          >
            <FooterLink
              _hover={{ textDecoration: "none" }}
              href={contactUsLink}
            >
              {contactUsMessage}
            </FooterLink>
          </Box>
          <Box>
            <FooterLink _hover={{ textDecoration: "none" }} href={dmazeLink}>
              dmaze.com
            </FooterLink>
          </Box>
        </Flex>
        <Box>
          <Text fontWeight={700} color="dmazegray.500" whiteSpace="nowrap">
            {copyRightMessage}
          </Text>
        </Box>
        <Box width="40%" />
      </Flex>
    </ChakraProvider>
  )
}
